export const API_URL = "https://mapi2.3sigmacrm.com/";
// export const API_URL = 'http://65.2.40.36:5000/';
export const APP_VERSION = "2.18.26"
export const SOCKET_API_URL = "https://mapi2.3sigmacrm.com/";
export const BASE_API_URL = "https://mapi2.3sigmacrm.com/api/v1";
export const client_secret = "2QJ4n_cwXzXDxqKY30MmcOgI";
export const BUCKET_URL = "https://all-user-version-4.s3.us-east-1.amazonaws.com/";
export const INTAPP_URL = "https://integration.3sigmacrm.com/";
export const WEB_APP_URL = "https://integration.3sigmacrm.com";
